// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kmfc","content":"styles_content__1l6SP","tableWrap":"styles_tableWrap__1fyof"};